<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 2),
                        href: meta.links.survey_index,
                    },
                    {
                        name: $tc('messages.survey_reports', 2),
                        href: null,
                    },
                    {
                        name: $tc('messages.students', 1),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <div class="sm:col-span-2">
                    <FormLabel :value="$t('messages.group')" for="active" />
                    <FormSelect
                        id="group_id"
                        v-model="form.group_id"
                        :options="options.groups"
                        :null-option="true"
                        class="mt-1 w-full"
                    />
                    <FormError :value="form.errors.group_id" class="mt-2" />
                </div>

                <div class="sm:col-span-2">
                    <div class="">
                        <FormLabel :value="$tc('messages.surveys', 1)" for="survey_id" />
                        <FormSelect
                            id="survey_id"
                            v-model="form.survey_id"
                            :options="options.surveys"
                            class="mt-1 w-full"
                            :null-option-text="
                                form.group_id
                                    ? $t('messages.select')
                                    : $t('messages.select_X', { X: $tc('messages.groups', 1) })
                            "
                        />
                        <FormError :value="form.errors.survey_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="">
                        <FormLabel :value="$tc('messages.students', 1)" for="student_id" />
                        <FormSelect
                            :null-option-text="$t('messages.select')"
                            id="student_id"
                            v-model="form.student_id"
                            :options="options.students"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.student_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_from')" for="date_from" />
                        <FormInput
                            id="date_from"
                            v-model="form.date_from"
                            type="date"
                            name="date_from"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.date_from" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_to')" for="date_to" />
                        <FormInput id="date_to" v-model="form.date_to" type="date" name="date_to" class="mt-1 w-full" />
                        <FormError :value="form.errors.date_to" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-4">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1 flex space-x-1 justify-end">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div class="mt-5" v-if="report">
            <SurveyReport :report="report" :survey="survey" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import SubmitFormButton from '../../../Activities/Subactivities/SubmitFormButton.vue';
import SurveyReport from '../partials/SurveyReport.vue';
import FormSelectGroupStudents from '../../../../../components/Forms/FormSelectGroupStudents.vue';

export default {
    components: {
        FormSelectGroupStudents,
        SurveyReport,
        FormInput,
        SubmitFormButton,
        FormError,
        FormLabel,
        FormSelect,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'options', 'filters', 'report', 'survey'],
    data() {
        return {
            form: this.$inertia.form({
                group_id: this.filters.group_id,
                survey_id: this.filters.survey_id,
                student_id: this.filters.student_id,
                date_from: this.filters.date_from,
                date_to: this.filters.date_to,
            }),
            selectedUsers: [],
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
